/* eslint-disable */

const type_schema = {
    description: "string",
    shampoos: [],
    leaveIns: [],
    conditioners: [],
}

const product_schema = {
    title: "string",
    image: "string",
    price: "string",
}

/* eslint-enable */

const products = {
    _1A: {
        description: "Type 1A Products",
        products: [
            {
                title: "Brush",
                image: "Brush.png",
                price: "$20",
            },
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Leave-In Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Spritz",
                image: "Leave-in 3.png",
                price: "$20",

            },
            {
                title: "Conditioner",
                image: "Conditioner.png",
                price: "$20",

            }
        ]

    },
    _1B: {
        description: "Type 1B Products",
        products: [
            {
                title: "Brush",
                image: "Brush.png",
                price: "$20",

            },
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Leave-In Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Spritz",
                image: "Leave-in 3.png",
                price: "$20",

            },
            {
                title: "Conditioner",
                image: "Conditioner.png",
                price: "$20",

            }
        ]

    },
    _1C: {
        description: "Type 1C Products",
        products: [
            {
                title: "Brush",
                image: "Brush.png",
                price: "$20",

            },
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Leave-In Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Spritz",
                image: "Leave-in 3.png",
                price: "$20",

            },
            {
                title: "Conditioner",
                image: "Conditioner.png",
                price: "$20",

            }
        ]

    },

    _2A: {
        description: "Type 2A Products",
        products: [
            {
                title: "Brush",
                image: "Brush.png",
                price: "$20",

            },
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Spritz",
                image: "Leave-in 3.png",
                price: "$20",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$30",

            },
        ],


    },

    _2B: {
        description: "Type 2B Products",
        products: [
            {
                title: "Brush",
                image: "Brush.png",
                price: "$20",

            },
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Spritz",
                image: "Leave-in 3.png",
                price: "$20",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$30",

            },
        ],


    },

    _2C: {
        description: "Type 2C Products",
        products: [
            {
                title: "Brush",
                image: "Brush.png",
                price: "$20",

            },
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Spritz",
                image: "Leave-in 3.png",
                price: "$20",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$30",

            },
        ],


    },

    _3A: {
        description: "Type 3A Products",
        products: [
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Comb",
                image: "Comb 2.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Pomade",
                image: "Pomade.png",
                price: "$10",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$20",

            }
        ]
    },

    _3B: {
        description: "Type 3B Products",
        products: [
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Comb",
                image: "Comb 2.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Pomade",
                image: "Pomade.png",
                price: "$10",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$20",

            }
        ]

    },
    _3C: {
        description: "Type 3C Products",
        products: [
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Comb",
                image: "Comb 2.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Pomade",
                image: "Pomade.png",
                price: "$10",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$20",

            }
        ]

    },



    _4A: {
        description: "Type 4A Products",
        products: [
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Comb",
                image: "Comb 2.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Pomade",
                image: "Pomade.png",
                price: "$10",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$20",

            },
            {
                title: "Hair Oil",
                image: "Oil.png",
                price: "$15",

            }
        ]

    },
    _4B: {
        description: "Type 4B Products",
        products: [
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Comb",
                image: "Comb 2.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Pomade",
                image: "Pomade.png",
                price: "$10",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$20",

            },
            {
                title: "Hair Oil",
                image: "Oil.png",
                price: "$15",

            }
        ]

    },
    _4C: {
        description: "Products for Type 4C",
        products: [
            {
                title: "Comb",
                image: "Comb.png",
                price: "$10",

            },
            {
                title: "Comb",
                image: "Comb 2.png",
                price: "$10",

            },
            {
                title: "Leave-in Conditioner",
                image: "Leave-in 1.png",
                price: "$15",

            },
            {
                title: "Pomade",
                image: "Pomade.png",
                price: "$10",

            },
            {
                title: "Shampoo + Conditioner",
                image: "Shampoo.png",
                price: "$20",

            },
            {
                title: "Hair Oil",
                image: "Oil.png",
                price: "$15",

            }
        ]

    }


}

export { products }